import React from "react";
import "../css/messageBubble.css";

export default function MessageBubble({ msg, self }) {
  const time = new Date(msg.timestamp).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className={`message-bubble ${self ? "sent" : "received"}`}>
      <div className="message-content">{msg.content}</div>
      <div className="message-time">{time}</div>
    </div>
  );
}